// extracted by mini-css-extract-plugin
module.exports = {"root":"UserMenu-styles_root__2Ja-g","item":"UserMenu-styles_item__3ze9P"};